import { formatPhone } from "../../../../../utils/format";

import TableCstmPs from "../../../../TableCstmPs/TableCstmPs";

const AssignmentsList = ({ assignments = [] }) => {
    const columns = [
        {
            header: "Recepcionista",
            accessor: "name",
            className: "tableCtype3",
        },

        {
            header: "Teléfono",
            accessor: "contact.phone",
            className: "tableCtype3",

            render: (value) => formatPhone(value),
        },

        {
            header: "Alumnos",
            accessor: "total_students",
            className: "tableCtype0 align-center",
        },

        {
            header: "Maestros",
            accessor: "teachers",
            className: "tableCtype3",

            render: (teachers = []) =>
                teachers.map((teacher) => teacher.name).join(", ") || 'No cuenta con maestros a su cargo',
        },
    ];

    return (
        <div className="assignments-list-container">
            <h1 className="title-2">Lista de recepcionistas con asignaciones</h1>
            <TableCstmPs
                columns={columns}
                data={assignments}
                variant="modern"
                emptyMessage="No hay asignaciones"
                styleOptions={{
                    hoverable: true,
                    rounded: true,
                    shadow: true,
                }}
                layout={{
                    borderMode: "separate",
                }}
            /></div>
    );
};

export default AssignmentsList;